import React from 'react';
import { Card, CardContent, Typography, List, ListItem, ListItemText, Icon, Stack, Divider } from '@mui/material';
import styled, { useTheme } from 'styled-components';

interface ListCardProps {
    icon: React.ReactElement;
    title: string;
    items: { title: string, value: string }[];
}

// make paper full height
const StyledCard = styled(Card)(({ theme }) => ({
    height: '100%',
    ".MuiPaper-root": {
        height: '100%',
    }
}));

const ListCard: React.FC<ListCardProps> = ({ icon, title, items }) => {
    const theme = useTheme();
    return (
        <StyledCard>
            <CardContent>
                <Stack gap={2}>
                    {icon}
                    <Typography variant="h5" component="h2">
                        {title}
                    </Typography>
                </Stack>
                <Stack gap={1} mt={theme.spacing(2)}>
                    {items.map((item, index) => (
                        <React.Fragment key={index} >
                            <Stack direction="row" justifyContent="space-between">
                                <Typography variant="subtitle1">{item.title}</Typography>
                                <Typography variant="report.card.info.value">{item.value}</Typography>
                            </Stack>
                            {index !== items.length - 1 && <Divider />}
                        </React.Fragment>
                    ))}
                </Stack>
            </CardContent>
        </StyledCard>
    );
};

export default ListCard;